<template>
    <div class="page-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="onBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">选择被护理人</span>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 被护理人列表 -->
        <div class="patient-list" v-if="!loading">
            <div
                    class="patient-item"
                    :class="{ selected: item.id === selectedPatientId }"
                    v-for="item in patientList"
                    :key="item.id"
                    :data-id="item.id"
                    @click="onSelectPatient(item.id)"
            >
                <div class="patient-checkbox">
                    <div class="checkbox" :class="{ checked: item.id === selectedPatientId }"></div>
                </div>
                <div class="patient-info">
                    <div class="patient-name-row">
                        <span class="patient-name">{{ item.name }}</span>
                        <span class="patient-tag">{{ item.age }}岁</span>
                        <span class="patient-tag">{{ item.gender }}</span>
                    </div>
                    <span class="patient-phone">联系电话 {{ item.phone }}</span>
                </div>
                <div class="patient-edit" :data-id="item.id" @click.stop="onEditPatient(item.id)">
                    <span>编辑</span>
                    <span class="arrow">></span>
                </div>
            </div>

            <!-- 空列表提示 -->
            <div class="empty-tip" v-if="patientList.length === 0">
                <span>暂无被护理人，请添加</span>
            </div>
        </div>

        <!-- 加载中 -->
        <div class="loading-tip" v-if="loading">
            <span>加载中...</span>
        </div>

        <!-- 添加按钮 -->
        <div class="add-btn" @click="onAddPatient">
            <span class="add-icon">+</span>
            <span>添加被陪护人</span>
        </div>

        <!-- 底部确认按钮 -->
        <div class="bottom-bar">
            <button class="confirm-btn" @click="onConfirm">确认</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'patientList',
        data() {
            return {
                enterpriseId: '',
                patientList: [],
                selectedPatientId: '',
                loading: true
            }
        },
        created() {
            // 页面创建时获取路由参数
            this.enterpriseId = this.$route.query.enterpriseId || ''
            if (this.enterpriseId) {
                this.fetchPatientList()
            }
        },
        activated() {
            // 从添加/编辑页面返回时刷新列表（Vue 路由缓存页面用）
            if (this.enterpriseId) {
                this.fetchPatientList()
            }
        },
        methods: {
            /**
             * 获取被护理人列表
             */
            async fetchPatientList() {
                try {
                    let url = "/api-enterprise/caregiver/patient/list"
                    let query = {
                        enterpriseId: this.enterpriseId
                    }
                    this.$api.post(url, query, response => {
                        if (response.data.result == "success") {
                            this.patientList = response.data.data
                            this.loading = false
                        }
                    })

                } catch (err) {
                    console.error('fetchPatientList fail:', err)
                    this.loading = false
                    this.$toast('获取列表失败')
                }
            },

            /**
             * 选择被护理人
             */
            onSelectPatient(id) {
                this.selectedPatientId = id
            },

            /**
             * 编辑被护理人
             */
            onEditPatient(id) {
                const patient = this.patientList.find(p => p.id === id)
                if (patient) {
                    // 全局存储编辑数据
                    localStorage.setItem('editPatient', JSON.stringify(patient));
                    this.$router.push({
                        path: '/patientForm',
                        query: {
                            enterpriseId: this.enterpriseId,
                            mode: 'edit'
                        }
                    })
                }
            },

            /**
             * 添加被护理人
             */
            onAddPatient() {
                // app.globalData.editPatient = null
                this.$router.push({
                    path: '/patientForm',
                    query: {
                        enterpriseId: this.enterpriseId,
                        mode: 'add'
                    }
                })
            },

            /**
             * 确认选择
             */
            onConfirm() {
                if (!this.selectedPatientId) {
                    this.$toast('请选择被护理人')
                    return
                }

                const patient = this.patientList.find(
                    p => p.id === this.selectedPatientId
                )
                if (patient) {
                    localStorage.setItem('selectedPatient', JSON.stringify(patient));
                    this.$router.back()
                }
            },

            /**
             * 返回上一页
             */
            onBack() {
                this.$router.back()
            }
        }
    }
</script>

<style scoped >
    .page-container {
        /* min-height: 50vh; */
        background-color: #f5f5f5;
        padding-bottom: 80px;
    }

    /* 导航栏 */
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* 被护理人列表 */
    .patient-list {
        padding: 10px 12px;
    }

    .patient-item {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 10px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    }

    .patient-item.selected {
        border: 1px solid #07c160;
    }

    .patient-checkbox {
        margin-right: 10px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
    }

    .checkbox.checked {
        border-color: #07c160;
        background-color: #07c160;
        position: relative;
    }

    .checkbox.checked::after {
        content: '✓';
        position: absolute;
        color: #fff;
        font-size: 12px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .patient-info {
        flex: 1;
    }

    .patient-name-row {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
    }

    .patient-name {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin-right: 8px;
    }

    .patient-tag {
        font-size: 15px;
        margin:0 5px;
        color: rgba(0, 184, 147, 0.72);
        background: rgba(187, 187, 187, 0.3);
        border-radius: 5px 5px 5px 5px;
        padding: 3px 5px;
    }

    .patient-phone {
        font-size: 14px;
        color: #999;
    }

    .patient-edit {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 13px;
    }

    .patient-edit .arrow {
        margin-left: 4px;
        color: #999;
    }

    /* 空列表提示 */
    .empty-tip {
        text-align: center;
        padding: 50px 0;
        color: #999;
        font-size: 14px;
    }

    /* 加载中提示 */
    .loading-tip {
        text-align: center;
        padding: 50px 0;
        color: #999;
        font-size: 14px;
    }

    /* 添加按钮 */
    .add-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        margin: 10px 12px;
        padding: 15px;
        border-radius: 8px;
        border: 1px dashed #07c160;
        color: #07c160;
        font-size: 15px;
    }

    .add-icon {
        font-size: 18px;
        margin-right: 5px;
    }

    /* 底部操作区 */
    .bottom-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 10px 15px;
        /*padding-bottom: calc(10px + env(safe-area-inset-bottom));*/
        box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05);
    }

    .confirm-btn {
        display: block;
        padding: 0;
        margin: auto;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: rgba(0, 184, 147, 0.72);
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-radius: 22px;
        border: none;
    }

    .confirm-btn::after {
        border: none;
    }
</style>
